module.exports = __webpack_public_path__ + "static/media/brand.a1d3bdb2.svg";